import React, { useCallback, useRef, useState } from 'react';
import Modal from 'src/Utils/CssModules/modal.module.css';
import Button from '../Button/Button';
import './SmallDialog.css'
import useOutsideClick from 'src/Utils/Hooks/UseOutSideClick/UseOutSideClick';
export interface ISmallDialogParams {
    title: string
    children: React.ReactNode,
    onSubmit: () => void,
    onClose: () => void,
    submitButtonText: string;
    submitButtonColor?:string;
    disableSubmit?:boolean;
    width?:string;
    submitButtonWidth?:string;
    cancelButtonWidth?:string;
    cancelButtonFontColor?:string;
    cancelButtonBorderColor?:string;
    cancelButtonFontWeight?:string;
}
const SmallDialog: React.FC<ISmallDialogParams> = ({ title, children, onSubmit, onClose, submitButtonText, width, submitButtonColor, disableSubmit, submitButtonWidth, cancelButtonWidth, cancelButtonFontColor,cancelButtonBorderColor, cancelButtonFontWeight }) => {
    const [display, setdisplay] = useState('block');
    const wrapperRef = useRef<HTMLDivElement>(null);
    useOutsideClick(wrapperRef, () => { close()})
    const close = useCallback(() => {
        setdisplay('none');
        onClose();
    }, [onClose]);
    const submit = useCallback(() => {
        setdisplay('none');
        onSubmit();
    }, [onSubmit]);
    return (
        <div className='row'>
            <div id="myModal" className={`${Modal.modal}`} style={{ display: display, zIndex: 1001 }}>
                <div className={`${Modal.content} smallcontent`} ref={wrapperRef} style={{width:width}}>
                    <div className={`${Modal.header} pb-2`} style={{ textAlign: 'center' }}>
                        <div style={{fontWeight:'600', fontSize: '24px', paddingRight: '26px'}}>{title}</div>
                    </div>
                
                    <div className={Modal.body} style={{padding:'1px 30px 0px 30px', textAlign: 'center'}}>
                        {children}
                    </div>
                
                    <div className={Modal.footer} style={{padding:'20px 17px 20px 31px'}}>
                        <div className="row" >
                         <div className='col-6 d-flex justify-content-end'>
                            <Button
                                  backgroundColor='none'
                                  color={cancelButtonFontColor ?? 'var(--primary-color)'}
                                  testId='close'
                                  onClick={() => { close() }}
                                  text='Cancel'
                                  width={cancelButtonWidth ?? '141px'}
                                  height='48px'
                                  borderRadius='24px'
                                  borderColor={cancelButtonBorderColor ?? "#D0D0D0"}
                                  fontWeight={cancelButtonFontWeight}
                                />
                            </div>
                            <div className='col-auto me-auto'>
                                <Button
                                  testId='ok'
                                  onClick={() => { submit() }}
                                  text={submitButtonText}
                                  width={submitButtonWidth ?? '141px'}
                                  backgroundColor={submitButtonColor}
                                  disable={disableSubmit}
                                />
                            </div>
  

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SmallDialog;